export default __webpack_public_path__ + "6845c0024a2376d981ecaba9c7ec82cd.jpg";